import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TmDecalrationDocumentsViewComponent } from '../tm-decalration-documents-view/tm-decalration-documents-view.component';
@Component({
  selector: 'tm-declaration-documents',
  templateUrl: './tm-declaration-documents.component.html',
  styleUrls: ['./tm-declaration-documents.component.scss']
})
export class TmDeclarationDocumentsComponent implements OnInit {


  @Input() masters;
  @Input() form_group;
  @Input() section;
  @Input() field;
  @Input() disabled_fields;
  @Input() save_filename = "fileName";
  @Input() save_cdnpath = "cdnPath";
  @Input() alertId;
  @Input() type;
  @Input() disableDownload;
  @Input() verificationRequired;
  @Input() callbackFn;
  @Input() verification_status_list;
  @Input() disabled;

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.form_group.get(this.field.fieldID).patchValue(this.masters[this.field.masterPropName]);
    console.log(this.masters[this.field.masterPropName]);
  }

  view(index) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '80%';
    dialogConfig.height = '80%';
    dialogConfig.data = {
      alertId: this.alertId,
      type: this.type
    }
    const dialogRef = this.dialog.open(TmDecalrationDocumentsViewComponent, dialogConfig);
    (dialogRef.componentInstance).index = index;
    (dialogRef.componentInstance).disableDownload = this.disableDownload;
    (dialogRef.componentInstance).decalration_documents = this.masters[this.field.masterPropName];
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.form_group.get(this.field.fieldID).patchValue(this.masters[this.field.masterPropName]);
      }
    }, err => {

    })
  }

}
